<template>
  <div id="my-dialogPc">
    <div class="top"><img src="../../assets/img/logo2.png" alt="" /></div>
    <div class="content">
      <div class="dialog-title">
        <div>
          {{ dialogData.title }}
        </div>
        <div
          class="alertContent"
          v-if="dialogData.title.indexOf('资料申请查看') != -1"
        >
          {{ alertContent }}
        </div>
      </div>

      <div class="goBack" @click="handleClick(dialogData.goBack.active)">
        <i class="el-icon-d-arrow-left"></i>
        {{ dialogData.goBack.btnName }}
      </div>
      <!-- 申请状态:验证身份,重置密码 -->
      <!-- 注册时不显示密码修改状态 -->
      <div class="verification" v-if="dialogData.showver">
        <div class="verification_outer">
          <div class="ver1">
            <div class="ver1_l">
              <div class="ver1_l_c"></div>
            </div>
            <div class="ver1_center"></div>
            <div class="ver1_l">
              <div class="ver1_l_c"></div>
            </div>
          </div>
          <div class="ver2">
            <span>验证身份</span>
            <span>重置密码</span>
          </div>
        </div>
      </div>

      <!-- 填写信息区 -->
      <div class="dialog-content customScrollBar">
        <div class="dialog-content_outer customScrollBar">
          <div
            class="line"
            v-for="(item, index) in dialogData.data"
            :key="index"
          >
            <div
              class="title"
              v-if="
                item.writeOrRead == 'write' ||
                (item.writeOrRead == 'read' &&
                  item.value.length > 0 &&
                  item.value != '')
              "
            >
              <!--              读状态下 则认为需要有值才显示左侧标题-->
              <div class="title_top" v-if="!item.nameflag">
                {{ item.name }}<span v-if="!item.isNull">*</span>
              </div>

              <span v-if="item.prompt">{{ item.prompt }}</span>
              <el-popover
                v-if="item.isTip"
                placement="top"
                title="标题"
                width="700"
                trigger="hover"
              >
                <span v-html="item.zhinan"></span>
                <span slot="reference">{{ item.isTip }}</span>
              </el-popover>
            </div>
            <!-- 文本格式 -->
            <div
              class="value yl"
              v-if="item.type == 'text' && item.value != ''"
            >
              {{ item.value }}
            </div>
            <!-- 图片预览 -->
            <div
              class="value yl"
              v-if="
                item.type == 'icons' &&
                item.writeOrRead == 'read' &&
                item.value.length > 0
              "
            >
              <div class="idcardImg" v-viewer="{ movable: false }">
                <div
                  class="idcardImgBox"
                  v-for="(it, i) in item.value"
                  :key="i"
                >
                  <div class="upbox">
                    <img :src="it.path" alt="" />
                    <span v-if="item.value.length == 0 || item.value == null"
                      >无</span
                    >
                  </div>
                </div>
                <!-- <div class="idcardImgBox">
                  <div class="upbox">
                    <img :src="item.value[1].path" alt="" />
                  </div>
                </div> -->
              </div>
            </div>
            <!-- pdf,jpg,png,jpeg文件格式查看 -->
            <div class="value yl" v-if="item.type == 'file_icons'">
              <div class="idcardImg" v-viewer="{ movable: false }">
                <div
                  class="idcardImgBox"
                  v-for="(it, i) in item.value"
                  :key="i"
                >
                  <div class="upbox">
                    <img :src="it.path" alt="" />
                    <span v-if="item.value.length == 0 || item.value == null"
                      >无</span
                    >
                  </div>
                </div>
                <!-- <div class="idcardImgBox">
                  <div class="upbox">
                    <img :src="item.value[1].path" alt="" />
                  </div>
                </div> -->
              </div>
            </div>

            <div class="value" v-if="item.type == 'input'">
              <el-input
                v-model="item.value"
                :placeholder="'请输入' + item.name"
                clearable
              ></el-input>
            </div>
            <div class="value" v-if="item.type == 'select'">
              <el-select
                v-model="item.value"
                :placeholder="'请选择' + item.name"
                filterable
              >
                <el-option
                  v-for="(it, i) in item.options"
                  :key="i"
                  :label="it.label"
                  :value="it.value"
                  :disabled="it.disabled"
                >
                </el-option>
              </el-select>
            </div>
            <div class="value" v-if="item.type == 'input_password'">
              <el-input
                v-model="item.value"
                :placeholder="'请输入' + item.name"
                show-password
              ></el-input>
            </div>
            <div class="value" v-if="item.type == 'input_password2'">
              <el-input
                v-model="item.value"
                :placeholder="'请输入' + item.name"
                show-password
                @blur="inputpassword"
                @focus="focuspassword"
              ></el-input>
            </div>
            <!--            img或者pdf的显示-->
            <div
              v-viewer="{ movable: false }"
              class="value pdfHrefArea"
              v-if="
                item.type == 'imgOrPdf' &&
                item.writeOrRead == 'read' &&
                item.value.length != 0
              "
              style="display: flex"
            >
              <div v-for="(item2, index2) in item.value" :key="index2 + '6'">
                <img
                  v-if="
                    item.value.length != 0 && item2.path.indexOf('pdf') == -1
                  "
                  class="showPicArea"
                  :src="item2.path"
                  alt=""
                  srcset=""
                />
                <span
                  v-if="
                    item.value.length != 0 && item2.name.indexOf('pdf') != -1
                  "
                  @click="openImg2(item2)"
                  >{{ item2.name }}</span
                >
              </div>
            </div>
            <!--            <div @click="showPdfMethod(item.value[0].name)" class="value pdfHrefArea"-->
            <!--                 v-if="item.type == 'showHref'">-->
            <!--              <span>{{ item.value[0].name }}</span>-->
            <!--            </div>-->
            <!-- 手机号 -->
            <div class="value" v-if="item.type == 'input_phone'">
              <el-input
                v-model="item.value"
                :placeholder="'请输入' + item.name"
                clearable
                @input="input"
              ></el-input>
            </div>
            <div class="value" v-if="item.type == 'switch'">
              <el-switch v-model="item.value" @change=""> </el-switch>
            </div>
            <!-- 获取手机验证码 -->
            <div class="value" v-if="item.type == 'input-yzm'">
              <el-input
                v-model="item.value"
                :placeholder="'请输入' + item.name"
              ></el-input>
              <div v-if="yzm" class="yzm" @click="getCode">获取验证码</div>
              <div v-if="!yzm" class="yzm1">重新发送({{ count }})</div>
            </div>

            <!-- 性别 -->
            <div class="value" v-if="item.type == 'radio'">
              <el-radio-group v-model="item.value">
                <div class="radio_outer">
                  <el-radio-button
                    :label="rad.label"
                    v-for="rad in item.options"
                  >
                    <div class="el_radio_button_div">{{ rad.label }}</div>
                  </el-radio-button>
                  <!-- <el-radio-button label="女">
                    <div class="el_radio_button_div">女</div>
                  </el-radio-button> -->
                </div>
              </el-radio-group>
            </div>
            <!-- 多图上传 -->
            <div
              class="value"
              style="background-color: #f7f7f7"
              v-if="item.type == 'uploadImg'"
            >
              <div
                class="item"
                v-for="(it, ii) in item.value"
                :key="ii"
                v-viewer="{ movable: false }"
              >
                <img :src="it.path" :alt="it.name" object-fi="contain" />
                <div
                  class="img-delete"
                  @click.stop="deleteImgNew(item.value, ii)"
                >
                  <i class="el-icon-delete"></i>
                </div>
              </div>
              <div class="item">
                <el-upload
                  class="upload-demo"
                  :action="action"
                  :headers="headers"
                  :show-file-list="false"
                  multiple
                  :data="{
                    title: item.uploadTitle,
                    project: '合肥城市学院',
                  }"
                  :before-upload="beforeAvatarUploadIMG"
                  :on-success="handleAvatarSuccess"
                  ><span>图片上传</span>
                </el-upload>
              </div>
            </div>

            <!-- 多图上传2 -->
            <div
              class="value"
              style="background-color: #f7f7f7"
              v-if="item.type == 'uploadImg2'"
            >
              <div class="value_top">
                <!-- 上传文件图片的入口 -->
                <div class="item_up">
                  <el-upload
                    class="upload-demo"
                    :action="action"
                    :headers="headers"
                    :show-file-list="false"
                    multiple
                    :data="{
                      title: item.uploadTitle,
                      project: '合肥城市学院',
                    }"
                    :before-upload="
                      (file) => {
                      return  beforeAvatarUploadImg(file, item);
                      }
                    "
                    :on-success="
                      (response, file, fileList, item) => {
                        handleAvatarSuccessImg(response, file, fileList, item);
                      }
                    "
                  >
                    <el-button v-if="item.writeOrRead == 'write'" type="primary"
                      >文件上传
                    </el-button>
                  </el-upload>
                </div>
              </div>
              <div style="width: 100%; display: flex; flex-wrap: wrap; height: auto;">
                <div
                  class="value_bottom"
                  v-for="(it, ii) in item.value"
                  :key="ii"
                >
                  <!-- 上传文件的格式是图片 -->
                  <div
                    class="value_btoom_c"
                    v-if="it.suffix == '1'"
                    v-viewer="{ movable: false }"
                  >
                    <img :src="it.path" :alt="it.name" object-fi="contain" />
                    <div
                      class="img-delete"
                      @click.stop="deleteImgNew2(item.value, ii)"
                    >
                      <i class="el-icon-delete"></i>
                    </div>
                  </div>
                  <!-- 上传文件的格式是pdf -->
                  <div class="value_btoom_c2" v-if="it.suffix == '0'">
                    <span @click="openImg2(it)" class="upBox_children_word">
                      {{ it.name }}</span
                    >
                    <span
                      class="error"
                      @click.stop="deleteUpImg2(item.value, ii)"
                      ><i class="el-icon-close" style="color: red"></i
                    ></span>
                  </div>
                </div>
              </div>
              <div class="fujianupload" v-if="item.name == '学籍资料审核表'">
                <span @click="fujianload(item.url)"
                  ><span v-if="item.writeOrRead == 'write'">点击下载:</span>
                  {{ item.fujianName }}</span
                >
              </div>
            </div>
            <!--多文件上传 -->

            <div class="value" v-if="item.type == 'uploadList'">
              <div class="uploadList">
                <div class="uploadList_top">
                  <el-upload
                    class="upload-demo"
                    :action="action"
                    :headers="headers"
                    :show-file-list="false"
                    multiple
                    :data="{
                      title: item.uploadTitle,
                      project: '合肥城市学院',
                    }"
                    :before-upload="beforeAvatarUpload"
                    :on-success="handleAvatarSuccess"
                  >
                    <el-button size="mini" type="primary">点击上传</el-button>
                  </el-upload>
                  <div class="uploadList_top_tip">
                    只能上传jpg/jpeg/png/pdf文件,且不超过5MB
                  </div>
                </div>
                <div class="upBox">
                  <div
                    class="upBox_children"
                    v-for="(it, ii) in item.fileList"
                    :key="ii"
                  >
                    <span @click="openImg(it)" class="upBox_children_word">
                      {{ it.name }}</span
                    >
                    <span
                      class="error"
                      @click.stop="deleteUpImg(item.fileList, ii)"
                      ><i class="el-icon-close"></i
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 身份证照片 -->
            <div class="value" v-if="item.type == 'idcardImg'">
              <div class="idcardImg">
                <div class="idcardImgBox_outer">
                  <div
                    class="idcardImgBox"
                    v-for="(it, i) in item.idcardImgLIst"
                    :key="i"
                  >
                    <el-upload
                      v-if="it.pathflag == 0"
                      class="avatar-uploader"
                      :action="action"
                      :show-file-list="false"
                      :headers="headers"
                      multiple
                      :data="{
                        title: item.uploadTitle,
                        project: '合肥城市学院',
                      }"
                      :on-success="
                        (response, file, fileList) => {
                          handleAvatarSuccess(response, file, fileList, i);
                        }
                      "
                      :before-upload="beforeAvatarUpload"
                    >
                      <span class="idcardImgBox_info">{{ it.info }}</span>
                      <div class="idcardImgBox_upload">
                        <img :src="it.path" alt="" object-fi="contain" />
                      </div>
                    </el-upload>
                    <div v-else style="height: 100%">
                      <div
                        class="idcardImgBox_upload"
                        v-if="it.pathflag == 1"
                        v-viewer="{ movable: false }"
                      >
                        <img :src="it.path" alt="" object-fi="contain" />
                      </div>
                      <div
                        class="img-delete"
                        @click.stop="deleteImg(item.idcardImgLIst, i)"
                      >
                        <i class="el-icon-delete"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 复选框 -->
            <div class="value" v-if="item.type == 'radio2'">
              <el-radio v-model="radio" label="非鼓励政策">
                <el-popover
                  placement="top"
                  title="非鼓励政策"
                  :width="flag == '1' ? '700' : '300'"
                  trigger="hover"
                >
                  <span
                    style="white-space: pre-line"
                    v-html="item.commonTxt"
                  ></span>
                  <span slot="reference">非鼓励政策</span>
                </el-popover>
              </el-radio>
              <el-radio v-model="radio" label="加分">
                <el-popover
                  placement="top"
                  title="鼓励政策（加分）"
                  :width="flag == '1' ? '700' : '300'"
                  trigger="hover"
                >
                  <span
                    style="white-space: pre-line"
                    v-html="item.withoutTestTxt"
                  ></span>
                  <span slot="reference">鼓励政策（加分）</span>
                </el-popover>
              </el-radio>
              <el-radio v-model="radio" label="免试">
                <el-popover
                  placement="top"
                  title="鼓励政策（免试或面试）"
                  :width="flag == '1' ? '700' : '300'"
                  trigger="hover"
                >
                  <span
                    style="white-space: pre-line"
                    v-html="item.otherScoreTxt"
                  ></span>
                  <span slot="reference">鼓励政策（免试或面试）</span>
                </el-popover>
              </el-radio>
            </div>

            <div
              class="value"
              style="background-color: #f7f7f7"
              v-if="item.type == 'uploadImg3'"
            >
              <div class="value_top">
                <!-- 上传文件图片的入口 -->
                <div class="item_up">
                  <el-upload
                    class="upload-demo"
                    :action="action"
                    :headers="headers"
                    :show-file-list="false"
                    multiple
                    :data="{
                      title: item.uploadTitle,
                      project: '合肥城市学院',
                    }"
                    :before-upload="
                      (file) => {
                       return beforeAvatarUploadImg(file, item);
                      }
                    "
                    :on-success="
                      (response, file, fileList, item) => {
                        handleAvatarSuccessImg(response, file, fileList, item);
                      }
                    "
                  >
                    <el-button v-if="item.writeOrRead == 'write'" type="primary"
                      >文件上传
                    </el-button>
                  </el-upload>
                </div>
              </div>
              <div  style="width: 100%; display: flex; flex-wrap: wrap; height: auto;">
                <div
                  class="value_bottom"
                  v-for="(it, ii) in item.value"
                  :key="ii" style="width: auto;"
                >
                  <!-- 上传文件的格式是图片 -->
                  <div
                    class="value_btoom_c"
                    v-if="it.suffix == '1'"
                    v-viewer="{ movable: false }"
                  >
                    <img :src="it.path" :alt="it.name" object-fi="contain" />
                    <div
                      class="img-delete"
                      @click.stop="deleteImgNew2(item.value, ii)"
                    >
                      <i class="el-icon-delete"></i>
                    </div>
                  </div>
                  <!-- 上传文件的格式是pdf -->
                  <div class="value_btoom_c2" v-if="it.suffix == '0'">
                    <span @click="openImg2(it)" class="upBox_children_word">
                      {{ it.name }}</span
                    >
                    <span
                      class="error"
                      @click.stop="deleteUpImg2(item.value, ii)"
                      ><i class="el-icon-close"></i
                    ></span>
                  </div>
                </div>
              </div>

              <div class="fujianupload" v-if="item.url.length > 0">
                <span @click="fujianload(fileItem.path)" v-for="fileItem in item.url" style="margin:0 10px;"
                  ><span v-if="item.writeOrRead == 'write'"
                    >点击下载 :{{ fileItem.name }} </span 
                  >
                  <span v-else>{{ fileItem.name }}</span>
                  </span
                >
              </div>

            </div>

            <!-- <div class="attload">
              <span @click="fujianload(item.url)">{{ item.fujianload }}</span>
            </div> -->
          </div>
          <div class="dialog-but">
            <div class="title"></div>
            <div
              class="valuebtn"
              v-for="(item, index) in dialogData.btns"
              :key="index"
              @click="handleClick(item.active)"
            >
              <span>{{ item.btnName }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "my_dialogPc",
  props: {
    myDialogData: {
      type: Object,
      default: function () {
        return {
          flag: true,
          title: "注册",
          data: [],
        };
      },
    },
  },
  data() {
    return {
      writeOrRead: "write",
      alertContent: "*当前已完成填写资料,仅供查看,请至首页查询审核结果", //查看状态下警示内容
      dialogData: this.myDialogData,
      // dialogData.suo: true, //获取验证码
      timeCont: 60,
      yzm: true, //
      timer: 0,
      count: 0,

      headers: {
        token: this.$token,
      },
      action: this.$baseurl + "/uploadFile",
      showFile: false,
      fileName: "",
      radio: "非鼓励政策",
      nameflag: true,
      flag: 0,
    };
  },
  methods: {
    showPdfMethod(value) {
      window.open(value, "_blank");
    },
    editPsw() {
      this.$emit("editPsw");
    },
    handleClick(active) {
      this.$emit("handleClick", active);
    },
    /* 输入手机号时显示发送验证码 */
    input() {
      for (let index = 0; index < this.dialogData.data.length; index++) {
        const element = this.dialogData.data[index];
        if (element.key == "phone" && element.value == "") {
          this.yzm = false;
        }
        if (element.key == "phone" && element.value != "") {
          this.yzm = true;
        }
      }
    },

    /* 发送验证码 */
    getCode() {
      for (let index = 0; index < this.dialogData.data.length; index++) {
        const element = this.dialogData.data[index];
        let requestData = {
          phone: "",
        };
        if (element.key == "phone") {
        }
        if (element.key == "phone" && element.value == "") {
          this.$message.error("手机号填写不能为空!");
          return;
        }
        if (
          element.key == "phone" &&
          !this.$mobilePhoneNumberCheck.mobilePhoneNumberCheck(element.value)
        ) {
          this.$message.error("请填写正确格式的手机号!");
          return;
        }
        if (element.key == "phone") {
          requestData.phone = element.value;
          if (!this.timer) {
            console.log(this.timer);
            this.count = 60;
            this.yzm = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= 60) {
                this.count--;
              } else {
                this.yzm = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
          this.$request(
            "post",
            "/sendVerificationCode",
            requestData,
            (data) => {
              //获取到手机验证码,1.页面控制,一分钟只能点一次
              this.dialogData.suo = false;
              this.$message({
                message: "已发送验证码,注意查收!",
                type: "success",
              });
            }
          );
        }
      }
    },
    /* 手机号校验 */

    inputpassword() {
      this.$emit("inputpassword");
    },
    focuspassword() {
      this.$emit("focuspassword");
    },
    /**
     * 图片上传前的校验
     */
    beforeAvatarUpload(file) {
      let isJPG =
        file.type === "image/jpg" ||
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/pdf";
      if (!isJPG) {
        this.$message.error("上传文件只能是 jpg,png,jpeg,pdf格式!");
      }
      return isJPG;
    },
    /**
     * 图片上传前的校验
     */

    beforeAvatarUploadImg(file, item) {
      console.log("图片上传前的格式校验", file, item);
      // //pdf格式
      // if (file.type === "application/pdf") {
      //   item.imgFlag = "0";
      // }
      // if (
      //   file.type === "image/jpg" ||
      //   file.type === "image/png" ||
      //   file.type === "image/jpeg"
      // ) {
      //   item.imgFlag = "1";
      // }
      // console.log("对象", item);
      let isJPG =
        file.type === "application/pdf" ||
        file.type === "image/jpg" ||
        file.type === "image/png" ||
        file.type === "image/jpeg";
      if (!isJPG) {
        this.$message.error("上传图片只能是 图片 格式或 pdf 格式!");
      }
      return isJPG;
    },
    handleAvatarSuccessImg(response, file, fileList, item) {
      console.log("上传图片成功", response, item);
      // item.imgFlag = response.result.suffix;
      console.log("上传图片", response, file, fileList);
      // 判断上传的文件是什么格式
      let path = response.result.path;
      let suffix = response.result.suffix;

      let name = response.result.name;

      let title = response.result.title;

      this.showFile = true;

      for (let index = 0; index < this.dialogData.data.length; index++) {
        const element = this.dialogData.data[index];

        if (element.key == "statusCheckFile" && title == "学籍资料审核表") {
          let obj = {
            name: name,
            path: path,
            suffix: suffix,
          };
          // element.value.push(obj);
          element.value.splice(0, 1, obj);
        }

        if (element.key == "withoutTestFile" && title == "加分(免试)") {
          let obj = {
            name: name,
            path: path,
            suffix: suffix,
          };
          if (element.value.length == 2) {
            //最多两张
            element.value.splice(1, 1);
            element.value.unshift(obj);
          } else {
            element.value.push(obj);
          }
          // element.value.push(obj);
        }
        if (element.key == "diplomaFile" && title == "中职毕业证原件上传") {
          let obj = {
            name: name,
            path: path,
            suffix: suffix,
          };

          element.value.splice(0, 1, obj);
          // element.value.push(obj);
        }

        if (element.key == "proveFile" && title == "报名材料") {
          let obj = {
            name: name,
            path: path,
            suffix: suffix,
          };
          // if (element.value.length == 2) {
          //   //最多两张
          //   element.value.splice(1, 1);
          //   element.value.unshift(obj);
          // } else {
          element.value.push(obj);
          // }
          // element.value.splice(0, 1, obj);
          // element.value.push(obj);
        }
      }
    },

    beforeAvatarUploadIMG(file) {
      console.log("图片上传前的格式校验", file);
      // let isJPG =
      //   file.type === "image/jpg" ||
      //   file.type === "image/png" ||
      //   file.type === "image/jpeg";
      // if (!isJPG) {
      //   this.$message.error("上传图片只能是 jpg 格式或 png 格式!");
      // }
      // return isJPG;
    },

    handleAvatarSuccess(response, file, fileList, imgIndex) {
      console.log("上传图片", response, file, fileList);
      // 判断上传的文件是什么格式
      let path = response.result.path;

      let name = response.result.name;

      let title = response.result.title;

      this.showFile = true;

      for (let index = 0; index < this.dialogData.data.length; index++) {
        const element = this.dialogData.data[index];

        if (element.key == "statusCheckFile" && title == "学籍资料审核表") {
          console.log("wqeqqweqeq", element);
          let obj = {
            name: name,
            path: path,
          };
          element.value.push(obj);
        }
        if (element.key == "stuStatusFile" && title == "所在学校学籍表") {
          let obj = {
            name: name,
            path: path,
          };

          element.value.push(obj);
        }
        if (element.key == "withoutTestFile" && title == "加分(免试)") {
          let obj = {
            name: name,
            path: path,
          };
          element.value.push(obj);
        }
        if (element.key == "diplomaFile" && title == "中职毕业证原件上传") {
          let obj = {
            name: name,
            path: path,
          };

          element.value.push(obj);
        }
        // if (element.key == "idCardFile" && title == "身份证图片") {
        //   console.log(element);
        //   let obj = {
        //     path: "",
        //     pathflag: 1,
        //     idCardflag: "1",
        //   };
        //   obj.path = path;
        //   element.idcardImgLIst.splice(imgIndex, 1, obj);
        //   if (imgIndex == 1) {
        //     element.idCardflag = "1";
        //   }
        // }
      }
    },

    //删除上传的文件(如学籍表,审核表)
    deleteUpImg(arr, index) {
      arr.splice(index, 1);
    },
    //删除上传的pdf
    deleteUpImg2(arr, index) {
      arr.splice(index, 1);
    },
    //打开上传图片的连接
    openImg(it) {
      window.open(it.path, "_blank");
    },

    /* 删除身份证照片 */
    deleteImg(arr, ind) {
      for (let index = 0; index < arr.length; index++) {
        arr[ind].path = "";
        if (ind == 0) {
          arr[ind].path = require("../../assets/img/sfzf.png");
          arr[ind].info = "点击上传身份证人像面图片";
          arr[ind].pathflag = 0;
        }
        if (ind == 1) {
          arr[ind].path = require("../../assets/img/sfzz.png");
          arr[ind].info = "点击上传身份证国徽面图片";
          arr[ind].pathflag = 0;
        }
      }
    },
    deleteImgNew(array, index) {
      array.splice(index, 1);
    },
    //
    deleteImgNew2(array, index) {
      array.splice(index, 1);
    },
    openImg2(it) {
      window.open(it.path, "_blank");
    },

    handleBeforePreview(file) {
      console.log("100000", file);
    },
    //免试加分指南附件下载
    fujianload(url) {
      window.open(url);
    },

    //获取各种政策信息接口
    // getFingerpost(){
    //   this.$request(
    //       "post",
    //       "/getFingerpost",
    //       null,
    //       (data) => {
    //         //获取到手机验证码,1.页面控制,一分钟只能点一次
    //         this.dialogData.data[15].fujianName=data.fingerpostFile.name
    //         console.log(this.dialogData)
    //       }
    //   );
    // }

    start() {
      if (window.screen.width / window.screen.height > 1) {
        this.flag = 1;
      } else {
        this.flag = 2;
      }
    },
  },
  mounted() {
    this.start();

    if (this.radio == "非鼓励政策") {
      this.dialogData.data.forEach((element) => {
        console.log("测试:", element, element.isNull);
        if (element.key == "withoutTestFile") {
          element.isNull = false;
        }
      });
    } else {
      this.dialogData.data.forEach((element) => {
        if (element.key == "withoutTestFile") {
          element.isNull = true;
        }
      });
    }
    this.myDialogData.radio = this.radio;
    //挂载上radio的值
    setTimeout(() => {
      if (!sessionStorage.getItem("enrollId").length > 0) {
        //手动刷新填写值
        this.dialogData.data[0].value = "加分";
        this.dialogData.data[0].value = "";
      }
    }, 1000);

    if (sessionStorage.getItem("enrollId").length > 0) {
      this.writeOrRead = "read";
    } else {
      this.writeOrRead = "write";
    }
    if (sessionStorage.getItem("generalRadio") != null) {
      this.radio = sessionStorage.getItem("generalRadio");
    }
    //console.log("数据2",this.radio)
  },

  watch: {
    radio(newVal, oldVal) {
      this.myDialogData.radio = newVal;
      // console.log(newVal, oldVal)
    },
    myDialogData(newVal, oldVal) {
      this.dialogData = newVal;
      console.log("新的值", newVal, oldVal);
    },
  },
};
</script>

<style lang="less" scoped>
#my-dialogPc {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  // justify-content: space-around;
  .top {
    width: 25rem;
    height: 5rem;
    box-sizing: border-box;
    margin: 10px 0;

    > img {
      width: 100%;
      height: 100%;
    }
  }

  .content {
    border-radius: 10px;
    width: 80%;
    max-width: 1200px;
    height: 74%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background: rgba(255, 255, 255, 1);
    position: relative;

    .dialog-title {
      width: 80%;
      height: 90px;
      line-height: 50px;
      font-size: 15px;
      font-weight: 700;
      border-bottom: 1px solid rgba(204, 204, 204, 1);
      position: relative;

      .alertContent {
        //position: absolute;
        //right: 0;
        font-size: 15px;
        color: red;
      }
    }

    .goBack {
      position: absolute;
      left: 15px;
      top: 15px;
      font-size: 15px;

      &:hover {
        cursor: pointer;
      }
    }

    .verification {
      width: 100%;
      height: 3.75rem;
      display: flex;
      justify-content: center;
      margin: 20px 0;

      .verification_outer {
        width: 66%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;

        .ver1 {
          width: 84%;
          display: flex;
          align-items: center;
          margin-right: 17px;

          .ver1_l {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            background: rgba(152, 188, 255, 1);
            display: flex;
            justify-content: center;
            align-items: center;

            .ver1_l_c {
              width: 9px;
              height: 9px;
              border-radius: 50%;
              background: rgba(51, 125, 255, 1);
            }
          }

          .ver1_center {
            flex: 1;
            height: 8px;
            background: rgba(224, 241, 255, 1);
          }
        }

        .ver2 {
          width: 88%;
          display: flex;
          justify-content: space-between;
        }
      }
    }

    .dialog-content {
      width: 100%;
      height: 90%;
      box-sizing: border-box;
      padding: 0 15px;
      display: flex;
      align-items: center;
      flex-direction: column;
      overflow-y: auto;

      .dialog-content_outer {
        width: 80%;
        display: flex;
        flex-direction: column;
        overflow-y: auto;

        .line {
          width: 94%;
          height: auto;
          box-sizing: border-box;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-top: 10px;

          .title {
            width: 20%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 14px;
            text-align: right;
            margin-right: 15px;

            .title_top {
              width: 100%;

              > span {
                color: red;
              }
            }

            > span {
              color: red;
            }
          }

          .value {
            width: 82%;
            min-height: 43px;
            height: auto;
            position: relative;
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            .yzm {
              position: absolute;
              right: 10px;
              top: 12px;
              color: rgba(0, 79, 148, 1);
              font-size: 14px;
              font-weight: 400;
              color: #7e7c7c;

              &:hover {
                // cursor: no-drop;
                cursor: pointer;
                color: rgb(7, 132, 241);
                // pointer-events: none;
              }
            }

            .yzm1 {
              position: absolute;
              right: 10px;
              top: 12px;
              color: #7e7c7c;
              font-size: 14px;
              font-weight: 400;
            }

            .el-select {
              width: 100% !important;
            }

            .radio_outer {
              width: 100%;
              display: flex;
            }

            .el_radio_button_div {
              width: 13vw;
              border-radius: 7px;
            }

            .uploadList {
              width: 100%;
              height: 100%;
              border-radius: 12px;
              background: rgba(247, 247, 247, 1);
              display: flex;
              flex-direction: column;
              padding: 2px 5px;
              box-sizing: border-box;
              align-items: flex-start;

              .uploadList_top {
                width: 100%;
                height: 40px;
                display: flex;
                align-items: center;

                .upPrompt {
                  font-size: 10px;
                  margin-left: 10px;
                }
              }

              .upBox {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                // justify-content: space-between;
                align-items: center;
                padding: 2px 5px;
                margin-bottom: 5px;
                box-sizing: border-box;

                .upBox_children {
                  // width: 50%;
                  display: flex;
                  font-size: 10px;
                  margin: 0 10px 10px 0;

                  .upBox_children_word {
                    &:hover {
                      text-decoration: underline;
                      cursor: pointer;
                    }
                  }

                  &:hover .error {
                    color: red;
                    text-decoration: none;
                    cursor: pointer;
                  }

                  .error {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 10px;
                    height: 10px;
                    font-size: 2px;
                    // color: red;
                    color: rgba(247, 247, 247, 1);
                    margin-left: 10px;
                  }
                }
              }

              > span {
                font-size: 12px;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
              }

              > img {
                width: 12px;
                height: 12px;
              }

              .file {
                font-size: 14px;
                letter-spacing: 1px;
                text-align: left;
              }
            }

            .idcardImg {
              width: 100%;
              display: flex;
              justify-content: space-between;

              .idcardImgBox_outer {
                width: 100%;
                display: flex;
                justify-content: space-between;

                .idcardImgBox {
                  width: 45%;
                  border-radius: 12px;
                  background: rgba(247, 247, 247, 1);
                  position: relative;

                  // > .idcardImgBox_info {
                  //   font-size: 10px;
                  //   font-weight: 400;
                  //   color: rgba(128, 128, 128, 1);
                  // }
                  /deep/ .el-upload.el-upload--text {
                    font-size: 12px;
                  }
                }
              }

              .idcardImgBox_view_outer {
                width: 100%;
                display: flex;
                justify-content: space-between;

                .idcardImgBox_view {
                  width: 45%;
                  border-radius: 12px;
                  background: rgba(247, 247, 247, 1);
                  position: relative;
                }
              }

              .idcardImgBox_upload {
                width: 100%;
                height: 100%;
                position: absolute;
                // height: 135px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: center;
                border-radius: 7px;
                position: relative;

                > img {
                  width: 160px;
                  height: 111px;
                }
              }

              .img-delete {
                width: 100%;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                left: 0;
                bottom: 0;
                opacity: 0;
                transition: 0.3s;
                background-color: #0a09093d;
                color: #fff;

                &:hover {
                  cursor: pointer;
                  opacity: 1;
                }
              }
            }

            .value_top {
              width: 100%;
              display: flex;
              padding: 10px;

              .item_up {
                > span {
                  font-size: 16px;
                }
              }
            }

            .value_bottom {
              width: 100%;
              // min-height: 130px;
              height: auto;
              box-sizing: border-box;
              padding: 0 10px;
              display: flex;
              align-items: center;
              flex-wrap: wrap;

              .value_btoom_c {
                width: 170px;
                height: 121px;
                padding: 5px;
                box-sizing: border-box;
                background: #fff;
                position: relative;

                > img {
                  width: 100%;
                  height: 100%;
                }

                .img-delete {
                  width: 100%;
                  height: 30px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  opacity: 0;
                  transition: 0.3s;
                  background-color: #0a09093d;
                  color: #fff;

                  &:hover {
                    cursor: pointer;
                    opacity: 1;
                  }
                }
              }

              .value_btoom_c2 {
                display: flex;
                padding: 0 10px;

                > span {
                  font-size: 15px;

                  &:hover {
                    cursor: pointer;
                  }
                }

                .error {
                  color: red;
                  display: block;
                  margin-left: 5px;
                }
              }

              > .item {
                width: 100%;
                min-height: 121px;
                height: auto;

                .item_top {
                  width: 170px;
                  height: 121px;
                  padding: 5px;
                  box-sizing: border-box;
                  display: flex;
                  flex-wrap: wrap;

                  > img {
                    width: 100%;
                    height: 100%;
                  }
                }
              }
            }

            .fujianupload {
              width: 100%;
              padding: 5px;
              font-size: 15px;
              font-weight: 700;
              display: flex;
              color: red;

              > sapn {
                color: red;
              }

              &:hover {
                cursor: pointer;
              }
            }

            > .item {
              width: 100%;
              min-height: 121px;
              height: auto;

              // width: 170px;
              // height: 121px;
              // padding: 5px;
              // box-sizing: border-box;
              // display: flex;
              // align-items: center;
              // justify-content: center;
              // margin: 8px;
              // border: 1px solid #c0c0c0;
              // border-radius: 3px;
              // color: #7e7c7c;
              // font-size: 11px;
              // background-color: #fff;
              // cursor: pointer;
              // position: relative;
              .item_top {
                width: 170px;
                height: 121px;
                padding: 5px;
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;

                > img {
                  width: 100%;
                  height: 100%;
                }

                .img-delete {
                  width: 100%;
                  height: 30px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  opacity: 0;
                  transition: 0.3s;
                  background-color: #0a09093d;
                  color: #fff;

                  &:hover {
                    cursor: pointer;
                    opacity: 1;
                  }
                }
              }

              .item_bottom {
                width: 100%;

                > span {
                  font-size: 12px;
                }
              }
            }
          }

          .yl {
            width: 76%;
            min-height: 43px;
            height: auto;
            position: relative;
            display: flex;
            align-items: center;
            background: rgba(247, 247, 247, 1);
            border-radius: 7px;
            padding-left: 10px;

            .idcardImg {
              width: 100%;
              height: 90px;
              display: flex;
              justify-content: space-between;

              .idcardImgBox {
                width: 45%;
                height: 90px;
                background: rgba(247, 247, 247, 1);
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;

                .upbox {
                  // width: 100%;
                  height: 90px;
                  opacity: 1;
                  border-radius: 7px;
                  background: rgba(247, 247, 247, 1);
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  > img {
                    width: 100%;
                    height: 100%;
                  }
                }
              }

              .idcardImgBox_upload {
                width: 100%;
                height: 100%;
                position: absolute;
                height: 135px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border-radius: 7px;
                position: relative;

                > img {
                  width: 160px;
                  height: 111px;
                }

                > span {
                  font-size: 10px;
                  font-weight: 400;
                  color: rgba(128, 128, 128, 1);
                }
              }
            }
          }

          .attload {
            width: 10%;
            height: 100%;

            // background: blueviolet;
            box-sizing: border-box;
            margin-left: 5px;
            color: red;
            display: flex;
            justify-content: center;
            align-items: center;

            > span {
              font-size: 10px;
              color: rgb(47, 0, 255);
            }

            &:hover {
              cursor: pointer;
            }
          }
        }
      }

      .dialog-but {
        width: 82%;
        height: 2.8125rem;
        box-sizing: border-box;
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        margin-top: 50px;

        .valuebtn {
          width: 76%;
          height: 43px;
          background: rgba(7, 80, 139, 1);
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 8px;

          &:hover {
            cursor: pointer;
          }

          > span {
            color: #fff;
          }
        }
      }
    }
  }

  .uploadList_top_tip {
    font-size: 10px;
    margin-left: 10px;
  }

  .pdfHrefArea {
    //border-bottom: 1px solid darkblue;
    cursor: pointer;
    background-color: #f7f7f7;
    border-radius: 7px;
    margin-left: 10px;
    padding-left: 10px;
    box-sizing: border-box;

    &:hover {
      color: #025bc0;
    }
  }

  .showPicArea {
    width: 300px;
    height: 160px;
    overflow: hidden;
    padding-left: 10px;
  }
}
</style>
